module.exports = __webpack_public_path__ + "static/media/Alexandra Galanter.947680ce.png";